import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuoteEmailAddRecFileModalPage } from './quote-email-add-rec-file-modal.page';

const routes: Routes = [
  {
    path: '',
    component: QuoteEmailAddRecFileModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuoteEmailAddRecFileModalPageRoutingModule {}
